import { render, staticRenderFns } from "./LicenseList.vue?vue&type=template&id=64014782&scoped=true"
import script from "./LicenseList.vue?vue&type=script&lang=js"
export * from "./LicenseList.vue?vue&type=script&lang=js"
import style0 from "./LicenseList.vue?vue&type=style&index=0&id=64014782&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64014782",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64014782')) {
      api.createRecord('64014782', component.options)
    } else {
      api.reload('64014782', component.options)
    }
    module.hot.accept("./LicenseList.vue?vue&type=template&id=64014782&scoped=true", function () {
      api.rerender('64014782', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/LicenseList.vue"
export default component.exports